import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const postSaveAdcd = async (payload) => {
  const res = await axiosInstance.post(API_ROUTES.SaveToken, payload)
  return res.data
}

export default postSaveAdcd
